module.exports = __webpack_public_path__ + "img/product-preview-70.a325612.png";